import { render, staticRenderFns } from "./wageTongcheng.vue?vue&type=template&id=3d97262c&"
import script from "./wageTongcheng.vue?vue&type=script&lang=js&"
export * from "./wageTongcheng.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports